import React from 'react';
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, Text, useColorModeValue } from '@chakra-ui/react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { ChevronRightIcon } from '@chakra-ui/icons';

function CustomBreadcrumb() {
  const location = useLocation();
  const textColor = useColorModeValue('gray.600', 'gray.400');
  const activeColor = useColorModeValue('blue.500', 'blue.300');
  const bgColor = useColorModeValue('gray.50', 'gray.700');

  // Function to generate breadcrumb items from pathname
  const generateBreadcrumbs = () => {
    const pathnames = location.pathname.split('/').filter((x) => x);
    const breadcrumbs = pathnames.map((value, index) => {
      const to = `/${pathnames.slice(0, index + 1).join('/')}`;
      const isLast = index === pathnames.length - 1;
      const label = value.split('%20').join(' '); // Replace %20 with space

      return {
        to,
        label: label.charAt(0).toUpperCase() + label.slice(1), // Capitalize first letter
        isLast,
      };
    });

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  // Return null if no breadcrumbs, but do it after all hooks are called
  if (breadcrumbs.length === 0) {
    return null;
  }

  return (
    <Breadcrumb
      spacing="8px"
      separator={<ChevronRightIcon color={textColor} />}
      py={4}
      px={8}
      bg={bgColor}
    >
      <BreadcrumbItem>
        <BreadcrumbLink as={RouterLink} to="/" color={textColor}>
          Home
        </BreadcrumbLink>
      </BreadcrumbItem>

      {breadcrumbs.map((breadcrumb) => (
        <BreadcrumbItem key={breadcrumb.to} isCurrentPage={breadcrumb.isLast}>
          {breadcrumb.isLast ? (
            <Text color={activeColor} fontWeight="bold">
              {breadcrumb.label}
            </Text>
          ) : (
            <BreadcrumbLink
              as={RouterLink}
              to={breadcrumb.to}
              color={textColor}
              _hover={{ color: activeColor }}
            >
              {breadcrumb.label}
            </BreadcrumbLink>
          )}
        </BreadcrumbItem>
      ))}
    </Breadcrumb>
  );
}

export default CustomBreadcrumb; 